(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
    const sectionSelector = '.shopify-section-group-header-group.announcement-bar-section';
    const sliderSelector = sectionSelector + ' [data-announcement-slider]';
    const slideSelector = '[data-announcement-slide]';
    const transparentTargetSelector = '[data-transparent-header]';
    const hiddenClass = 'is-hidden-over-transparent';
    const controllers = new WeakMap();
    let editorCleanup = null;
    let initialized = false;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getTransparentTargets = (announcementSection) => {
      return Array.from(document.querySelectorAll(transparentTargetSelector)).filter((target) => {
        if (announcementSection.contains(target)) return false;

        const styles = window.getComputedStyle(target);
        return styles.display !== 'none' && styles.visibility !== 'hidden';
      });
    };

    const createVisibilityController = (sliderElement) => {
      const announcementSection = sliderElement.closest(sectionSelector);

      if (!announcementSection) return { refresh() {}, update() {}, destroy() {}};
      
      const HIDE_OVERLAP_THRESHOLD = 12;
      const SHOW_OVERLAP_THRESHOLD = 2;
      const HEADER_GROUP_UPDATE_EVENT = "header-group:offsets:update";
      let transparentTargets = [];
      let resizeObserver = null;
      let expandedHeight = 0;
      let isHidden = announcementSection.classList.contains(hiddenClass);

      const updateExpandedHeight = () => {
        const height = Math.ceil(sliderElement.getBoundingClientRect().height);
        if (height <= 0) return;
        expandedHeight = height;
        announcementSection.style.setProperty("--announcement-bar-expanded-height", `${height}px`);
      };

      const requestHeaderGroupUpdate = () => {
        window.requestAnimationFrame(() => document.dispatchEvent(new CustomEvent(HEADER_GROUP_UPDATE_EVENT)));
      };

      const setHiddenState = (nextHiddenState) => {
        if (nextHiddenState === isHidden) return;
      
        isHidden = nextHiddenState;
        announcementSection.classList.toggle(hiddenClass, nextHiddenState);
        announcementSection.setAttribute("aria-hidden", String(nextHiddenState));
        requestHeaderGroupUpdate();
      };

      const getDetectionRect = () => {
        const sectionRect = announcementSection.getBoundingClientRect();
        const detectionHeight = expandedHeight || Math.ceil(sliderElement.getBoundingClientRect().height);

        return {
          top: sectionRect.top,
          bottom: sectionRect.top + detectionHeight,
          left: sectionRect.left,
          right: sectionRect.right,
          width: sectionRect.width,
          height: detectionHeight,
        };
      };

      const getOverlap = (announcementRect, targetRect) => {
        const horizontalOverlap = Math.min(announcementRect.right, targetRect.right) - Math.max(announcementRect.left, targetRect.left);
        if (horizontalOverlap <= 0) return 0;
      
        const verticalOverlap = Math.min(announcementRect.bottom, targetRect.bottom) - Math.max(announcementRect.top, targetRect.top);
      
        return Math.max(0, Math.round(verticalOverlap));
      };

      const updateVisibility = () => {
        updateExpandedHeight();
        const detectionRect = getDetectionRect();

        if (detectionRect.width <= 0 || detectionRect.height <= 0) {
          setHiddenState(false);
          return;
        }

        const maximumOverlap = transparentTargets.reduce((maximum, target) => {
          const targetRect = target.getBoundingClientRect();
          return Math.max(maximum, getOverlap(detectionRect, targetRect));
        }, 0);

        if (isHidden) {
          if (maximumOverlap <= SHOW_OVERLAP_THRESHOLD) setHiddenState(false);
          return;
        }

        if (maximumOverlap >= HIDE_OVERLAP_THRESHOLD) setHiddenState(true);
      };

      const requestUpdate = updateVisibility;
      const refreshTargets = () => {
        updateExpandedHeight();
        transparentTargets = getTransparentTargets(announcementSection);
        resizeObserver?.disconnect();

        if (typeof ResizeObserver !== "undefined") {
          resizeObserver = new ResizeObserver(requestUpdate);
          resizeObserver.observe(sliderElement);
          transparentTargets.forEach((target) => resizeObserver.observe(target));
        }
        requestUpdate();
      };
      window.addEventListener("scroll", requestUpdate, { passive: true });
      document.addEventListener('header-group:layout-ready', requestUpdate);
      refreshTargets();

      return {
        refresh: refreshTargets,
        update: requestUpdate,
        destroy() {
          window.removeEventListener("scroll", requestUpdate);
          document.removeEventListener('header-group:layout-ready',requestUpdate);
          resizeObserver?.disconnect();
          requestUpdate.cancel();
          announcementSection.style.removeProperty("--announcement-bar-expanded-height");
          setHiddenState(false);
        }
      };
    };

    const initializeAnnouncementSlider = (sliderElement) => {
      const existingInstance = window.swiperFunctions.getInstance(sliderElement);

      if (existingInstance) return existingInstance;

      const slides = Array.from(sliderElement.querySelectorAll(slideSelector));

      if (!slides.length) return null;

      const hasMultipleSlides = slides.length > 1;
      const autoplayEnabled = sliderElement.dataset.autoplay === 'true' && hasMultipleSlides;
      const autoplaySpeed = Number.parseInt(sliderElement.dataset.autoplaySpeed, 10) || 5000;
      const visibilityController = createVisibilityController(sliderElement);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: prefersReducedMotion ? 0 : 450,
        autoHeight: false,
        watchOverflow: true,
        allowTouchMove: hasMultipleSlides,
        simulateTouch: hasMultipleSlides,
        grabCursor: hasMultipleSlides,
        loop: hasMultipleSlides,
        rewind: false,
        keyboard: {
          enabled: hasMultipleSlides,
          onlyInViewport: true,
        },
        autoplay: autoplayEnabled && !prefersReducedMotion ? {
          delay: autoplaySpeed,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          waitForTransition: true,
        } : false,
        onResize() {
          visibilityController.update();
        },
        on: {
          init(swiperInstance) {
            swiperInstance.updateAutoHeight?.(0);
            visibilityController.refresh();
          },

          slideChangeTransitionEnd(swiperInstance) {
            swiperInstance.updateAutoHeight?.(prefersReducedMotion ? 0 : 300);
            visibilityController.update();
          }
        }
      });

      if (!instance) {
        visibilityController.destroy();
        return null;
      }

      controllers.set(sliderElement, { visibilityController });
      visibilityController.refresh();
      return instance;
    };

    const destroyAnnouncementSlider = (sliderElement) => {
      const controller = controllers.get(sliderElement);
      controller?.visibilityController?.destroy();
      window.swiperFunctions.destroy(sliderElement);
      controllers.delete(sliderElement);
    };

    const initializeCurrentSlider = () => {
      const sliderElement = document.querySelector(sliderSelector);
      if (!sliderElement) return null;
      return initializeAnnouncementSlider(sliderElement);
    };

    const initializeModule = () => {
      if (initialized) return;
      initialized = true;
      initializeCurrentSlider();

      editorCleanup = window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeAnnouncementSlider,
        destroyElement: destroyAnnouncementSlider,
        shouldRestartAutoplay({ sliderElement }) {
          return sliderElement.dataset.autoplay === 'true' && !prefersReducedMotion;
        },
        onSectionLoad(event, sliderElement) {
          if (!sliderElement) return;
          controllers.get(sliderElement)?.visibilityController?.refresh();
        }
      });
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.collectionListSwiperModuleInitialized) return;
    window.collectionListSwiperModuleInitialized = true;

    const sliderSelector = '[data-collection-list-slider]';
    const slideSelector = '[data-collection-list-slide]';
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let editorCleanup = null;

    const getShell = (sliderElement) => sliderElement.closest('[data-collection-list-shell]');

    const shouldEnableSlider = (sliderElement) => {
      return desktopMedia.matches
        ? sliderElement.dataset.desktopSlider === 'true'
        : sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-collection-list-previous], [data-collection-list-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-collection-list-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-collection-list-previous], [data-collection-list-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-collection-list-pagination]');
      if (pagination) {
        pagination.className = 'collection-list-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroyCollectionSlider = (sliderElement) => {
      if (!sliderElement) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeCollectionSlider = (sliderElement) => {
      if (!sliderElement) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyCollectionSlider(sliderElement);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setActiveState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-collection-list-previous]');
      const nextButton = shell?.querySelector('[data-collection-list-next]');
      const pagination = shell?.querySelector('[data-collection-list-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        loop: slides.length > Math.max(columnsDesktop, columnsMobile),
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            spaceBetween: 24,
          },
        },
        onResize(swiperInstance) {
          swiperInstance.update();
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeCollectionSlider(sliderElement);
        } else {
          destroyCollectionSlider(sliderElement);
        }
      });
    };

    const initializeModule = () => {
      synchronizeSliders();

      editorCleanup = window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeCollectionSlider,
        destroyElement: destroyCollectionSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) initializeCollectionSlider(sliderElement);
        },
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', synchronizeSliders);
      } else {
        desktopMedia.addListener(synchronizeSliders);
      }
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const moduleFlag = 'standardCollectionListMobileSwiperModuleInitialized';

    if (window[moduleFlag]) return;
    window[moduleFlag] = true;

    const sliderSelector = '[data-standard-collection-list-slider]';
    const slideSelector = '[data-standard-collection-list-slide]';
    const shellSelector = '[data-standard-collection-list-shell]';
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => sliderElement.closest(shellSelector);

    const shouldEnableSlider = (sliderElement) => {
      return mobileMedia.matches && sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      getShell(sliderElement)?.classList.toggle('is-swiper-active', active);
    };

    const destroyCollectionListSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeCollectionListSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyCollectionListSlider(sliderElement);
        return null;
      }

      const slides = Array.from(sliderElement.querySelectorAll(slideSelector));
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      if (slides.length <= columnsMobile) {
        destroyCollectionListSlider(sliderElement);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);

      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const spaceBetween = Math.max(0, Number.parseFloat(sliderElement.dataset.spaceBetween) || 0);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        slidesPerGroup: 1,
        spaceBetween,
        speed: prefersReducedMotion ? 0 : 400,
        watchOverflow: true,
        loop: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        roundLengths: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: {
          enabled: true,
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeCollectionListSlider(sliderElement);
        } else {
          destroyCollectionListSlider(sliderElement);
        }
      });
    };

    const initializeModule = () => {
      synchronizeSliders();

      window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeCollectionListSlider,
        destroyElement: destroyCollectionListSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) initializeCollectionListSlider(sliderElement);
        },
      });

      if (typeof mobileMedia.addEventListener === 'function') {
        mobileMedia.addEventListener('change', synchronizeSliders);
      } else {
        mobileMedia.addListener(synchronizeSliders);
      }
    };

    const startModule = () => {
      if (window.swiperFunctions) {
        initializeModule();
      } else {
        document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startModule, { once: true });
    } else {
      startModule();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-with-filters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.featuredCollectionTabsModuleInitialized) return;
    window.featuredCollectionTabsModuleInitialized = true;

    const sectionSelector = '[data-featured-tabs-section]';
    const sliderSelector = '[data-featured-tabs-slider]';
    const slideSelector = '[data-featured-tabs-slide]';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => sliderElement.closest('[data-featured-tabs-slider-shell]');

    const setSliderState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-featured-tabs-previous], [data-featured-tabs-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-featured-tabs-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-featured-tabs-previous], [data-featured-tabs-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-featured-tabs-pagination]');
      if (pagination) {
        pagination.className = 'featured-tabs__pagination';
        pagination.replaceChildren();
      }
    };

    const destroySlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setSliderState(sliderElement, false);
    };

    const initializeSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setSliderState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setSliderState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-featured-tabs-previous]');
      const nextButton = shell?.querySelector('[data-featured-tabs-next]');
      const pagination = shell?.querySelector('[data-featured-tabs-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      setSliderState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        slidesPerGroup: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        rewind: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            slidesPerGroup: columnsDesktop,
            spaceBetween: 24,
          },
        },
        on: {
          init() {
            setSliderState(sliderElement, true);
          },
          resize(swiperInstance) {
            swiperInstance.update();
          },
          destroy() {
            setSliderState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setSliderState(sliderElement, false);
      }

      return instance;
    };

    const activateTab = (sectionElement, selectedTab, focusTab = false) => {
      if (!sectionElement || !selectedTab) return;

      const targetId = selectedTab.dataset.featuredTabsTarget;
      const tabs = Array.from(sectionElement.querySelectorAll('[data-featured-tabs-tab]'));
      const panels = Array.from(sectionElement.querySelectorAll('[data-featured-tabs-panel]'));
      const targetPanel = panels.find((panel) => panel.dataset.featuredTabsPanelId === targetId);

      if (!targetPanel) return;

      tabs.forEach((tab) => {
        const isActive = tab === selectedTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel !== targetPanel;
      });

      if (focusTab) selectedTab.focus();

      window.requestAnimationFrame(() => {
        const sliderElement = targetPanel.querySelector(sliderSelector);
        const instance = initializeSlider(sliderElement);
        instance?.update();
      });
    };

    const initializeSection = (sectionElement) => {
      if (!sectionElement || sectionElement.dataset.featuredTabsInitialized === 'true') return;

      sectionElement.dataset.featuredTabsInitialized = 'true';

      const tabs = Array.from(sectionElement.querySelectorAll('[data-featured-tabs-tab]'));
      if (!tabs.length) return;

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(sectionElement, tab));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex === null) return;

          event.preventDefault();
          activateTab(sectionElement, tabs[nextIndex], true);
        });
      });

      const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(sectionElement, activeTab);
    };

    const destroySection = (sectionElement) => {
      if (!sectionElement) return;

      sectionElement.querySelectorAll(sliderSelector).forEach(destroySlider);
      delete sectionElement.dataset.featuredTabsInitialized;
    };

    const initializeAllSections = () => {
      document.querySelectorAll(sectionSelector).forEach(initializeSection);
    };

    const initializeModule = () => {
      initializeAllSections();

      document.addEventListener('shopify:section:load', (event) => {
        const sectionElement = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        initializeSection(sectionElement);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const sectionElement = event.target.matches(sectionSelector)
          ? event.target
          : event.target.querySelector(sectionSelector);

        destroySection(sectionElement);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail?.blockId;
        let selectedTab = event.target.closest?.('[data-featured-tabs-tab]');
        let sectionElement = selectedTab?.closest(sectionSelector);

        if (!selectedTab && blockId) {
          document.querySelectorAll(sectionSelector).forEach((candidateSection) => {
            if (selectedTab) return;

            const candidateTab = Array.from(
              candidateSection.querySelectorAll('[data-featured-tabs-tab]')
            ).find((tab) => tab.dataset.featuredTabsBlockId === blockId);

            if (candidateTab) {
              selectedTab = candidateTab;
              sectionElement = candidateSection;
            }
          });
        }

        if (selectedTab && sectionElement) activateTab(sectionElement, selectedTab);
      });
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector(".section-header");
      
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type") === "always" || this.getAttribute("data-sticky-type") === "reduce-logo-size";
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");
      this.transparentTargetSelector = "[data-transparent-header]";
      this.enterOverlapThreshold = 12;
      this.exitOverlapThreshold = 2;
      this.transparentTargets = [];
      this.isOverTransparent = null;
      this.updateHeaderGroupOffsets = this.updateHeaderGroupOffsets.bind(this);
      this.refreshHeaderGroupSections = this.refreshHeaderGroupSections.bind(this);
      this.refreshTransparentTargets = this.refreshTransparentTargets.bind(this);
      this.requestTransparencyUpdate = this.requestTransparencyUpdate.bind(this);
      this.initialTransparencySet = this.initialTransparencySet.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.onHeaderGroupOffsetsUpdate = () => {
        requestAnimationFrame(this.updateHeaderGroupOffsets);
      };

      document.addEventListener("header-group:offsets:update", this.onHeaderGroupOffsetsUpdate);
      document.addEventListener("header-group:layout-ready", this.requestTransparencyUpdate);
      this.headerGroupResizeObserver = new ResizeObserver(this.updateHeaderGroupOffsets);
      this.transparencyResizeObserver = new ResizeObserver(this.requestTransparencyUpdate);
      this.setHeaderHeight();
      this.refreshHeaderGroupSections();
      this.refreshTransparentTargets();

      this.onBreakpointChange = () => {
        this.setHeaderHeight();
        this.refreshHeaderGroupSections();
        this.refreshTransparentTargets();
      };

      this.breakpointMediaQuery = window.matchMedia("(max-width: 990px)");
      this.breakpointMediaQuery.addEventListener("change", this.onBreakpointChange);
      this.onShopifySectionChange = () => {
        requestAnimationFrame(() => {
          this.refreshHeaderGroupSections();
          this.refreshTransparentTargets();
        });
      };
      document.addEventListener("shopify:section:load", this.onShopifySectionChange);
      document.addEventListener("shopify:section:unload", this.onShopifySectionChange);
      this.onWindowLoad = this.initialTransparencySet;
      window.addEventListener("load", this.onWindowLoad, { once: true });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add("shopify-section-header-sticky");
      }

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, { passive: true });
      this.createObserver();
      this.initialTransparencySet();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
    }

    initialTransparencySet() {
      window.cancelAnimationFrame(this.initialLayoutFrame);
      window.cancelAnimationFrame(this.initialDetectionFrame);

      this.initialLayoutFrame = window.requestAnimationFrame(() => {
        this.setHeaderHeight();
        this.refreshHeaderGroupSections();
        this.refreshTransparentTargets();
        this.initialDetectionFrame = window.requestAnimationFrame(() => {
          this.updateTransparencyState();
        });
      });
    }

    getTransparentTargets() {
      return Array.from(document.querySelectorAll(this.transparentTargetSelector)).filter((target) => {
        if (this.header.contains(target)) {
          return false;
        }

        const styles = window.getComputedStyle(target);
        return styles.display !== "none" && styles.visibility !== "hidden";
      });
    }

    refreshTransparentTargets() {
      this.transparentTargets = this.getTransparentTargets();
      this.transparencyResizeObserver.disconnect();
      this.transparencyResizeObserver.observe(this.header);
          
      this.transparentTargets.forEach((target) => {
        this.transparencyResizeObserver.observe(target);
      });
      this.requestTransparencyUpdate();
    }

    requestTransparencyUpdate() {
      if (this.transparencyFrame !== undefined) {
        return;
      }

      this.transparencyFrame = window.requestAnimationFrame(() => {
        this.transparencyFrame = undefined;
        this.updateTransparencyState();
      });
    }

    getOverlap(headerRect, targetRect) {
      const horizontalOverlap = Math.min(headerRect.right, targetRect.right) - Math.max(headerRect.left, targetRect.left);
      if (horizontalOverlap <= 0) {
        return 0;
      }

      const verticalOverlap = Math.min(headerRect.bottom, targetRect.bottom) - Math.max(headerRect.top, targetRect.top);
      return Math.max(0, Math.round(verticalOverlap));
    }

    setTransparentState(nextState) {
      if (nextState === this.isOverTransparent) {
        return;
      }

      this.isOverTransparent = nextState;
      this.header.classList.toggle("is-over-transparent-header", nextState);
      this.header.classList.toggle("scrolled-past-header", !nextState);
    }

    updateTransparencyState() {
      const headerRect = this.header.getBoundingClientRect();
      if (headerRect.width <= 0 || headerRect.height <= 0) {
        return;
      }

      const maximumOverlap = this.transparentTargets.reduce((maximum, target) => {
        const targetRect = target.getBoundingClientRect();
        return Math.max(maximum, this.getOverlap(headerRect, targetRect));
      }, 0);
      if (this.isOverTransparent === true) {
        if (maximumOverlap <= this.exitOverlapThreshold) {
          this.setTransparentState(false);
        }

        return;
      }

      if (maximumOverlap >= this.enterOverlapThreshold) {
        this.setTransparentState(true);
        return;
      }

      if (this.isOverTransparent === null) {
        this.setTransparentState(false);
      }
    }

    refreshHeaderGroupSections() {
      this.headerGroupSections = Array.from(document.querySelectorAll(".shopify-section-group-header-group"));
      this.headerGroupResizeObserver.disconnect();
      this.headerGroupSections.forEach((section) => {
        this.headerGroupResizeObserver.observe(section);
      });
      this.updateHeaderGroupOffsets();
    }

    updateHeaderGroupOffsets() {
      let accumulatedTop = 0;
      this.headerGroupSections.forEach((section) => {
        section.style.top = `${accumulatedTop}px`;
        accumulatedTop += section.getBoundingClientRect().height;
      });
      document.dispatchEvent(new CustomEvent("header-group:layout-ready"));
    }

    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.removeEventListener("scroll", this.onScrollHandler);
      window.removeEventListener("load", this.onWindowLoad);
      this.breakpointMediaQuery?.removeEventListener("change", this.onBreakpointChange);
      document.removeEventListener("header-group:offsets:update", this.onHeaderGroupOffsetsUpdate);
      document.removeEventListener("header-group:layout-ready", this.requestTransparencyUpdate);
      document.removeEventListener("shopify:section:load", this.onShopifySectionChange);
      document.removeEventListener("shopify:section:unload", this.onShopifySectionChange);
      this.headerGroupResizeObserver?.disconnect();
      this.transparencyResizeObserver?.disconnect();
      window.cancelAnimationFrame(this.initialLayoutFrame);
      window.cancelAnimationFrame(this.initialDetectionFrame);
      window.cancelAnimationFrame(this.transparencyFrame);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, intersectionObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        intersectionObserver.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      this.requestTransparencyUpdate();
      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-sticky", "animate");
      this.header.classList.remove("shopify-section-header-hidden");
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll("header-menu");
      this.disclosures.forEach((disclosure) => {
        disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector("details-modal");
      this.searchModal?.close(false);
    }
  }

  if (!customElements.get("sticky-header")) {
    customElements.define("sticky-header", StickyHeader);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.testimonialsSwiperModuleInitialized) return;
    window.testimonialsSwiperModuleInitialized = true;

    const sliderSelector = '[data-testimonials-slider]';
    const slideSelector = '[data-testimonials-slide]';
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getShell = (sliderElement) => {
      return sliderElement.closest('[data-testimonials-shell]');
    };

    const shouldEnableSlider = (sliderElement) => {
      return desktopMedia.matches
        ? sliderElement.dataset.desktopSlider === 'true'
        : sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-testimonials-previous], [data-testimonials-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-testimonials-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-testimonials-previous], [data-testimonials-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-testimonials-pagination]');

      if (pagination) {
        pagination.className = 'testimonials-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroyTestimonialsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeTestimonialsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyTestimonialsSlider(sliderElement);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);

      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);

      if (slides.length < 2) {
        setActiveState(sliderElement, false);
        return null;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-testimonials-previous]');
      const nextButton = shell?.querySelector('[data-testimonials-next]');
      const pagination = shell?.querySelector('[data-testimonials-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 1);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        loop: slides.length > Math.max(columnsDesktop, columnsMobile),
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: false,
        pagination: false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            spaceBetween: 24,
          },
        },
        onResize(swiperInstance) {
          swiperInstance.update();
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeTestimonialsSlider(sliderElement);
        } else {
          destroyTestimonialsSlider(sliderElement);
        }
      });
    };

    const initializeModule = () => {
      synchronizeSliders();

      window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeTestimonialsSlider,
        destroyElement: destroyTestimonialsSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) initializeTestimonialsSlider(sliderElement);
        },
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', synchronizeSliders);
      } else {
        desktopMedia.addListener(synchronizeSliders);
      }
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, {
        once: true,
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (() => {
    if (window.relatedProductsSwiperModuleInitialized) return;
    window.relatedProductsSwiperModuleInitialized = true;

    const sliderSelector = '[data-related-products-slider]';
    const slideSelector = '[data-related-products-slide]';
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let editorCleanup = null;
    let recommendationsObserver = null;

    const getShell = (sliderElement) => sliderElement.closest('[data-related-products-shell]');

    const shouldEnableSlider = (sliderElement) => {
      return desktopMedia.matches
        ? sliderElement.dataset.desktopSlider === 'true'
        : sliderElement.dataset.mobileSlider === 'true';
    };

    const setActiveState = (sliderElement, active) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.classList.toggle('is-swiper-active', active);

      shell.querySelectorAll('[data-related-products-previous], [data-related-products-next]').forEach((button) => {
        button.tabIndex = active ? 0 : -1;
        button.setAttribute('aria-hidden', String(!active));
      });

      const pagination = shell.querySelector('[data-related-products-pagination]');
      pagination?.setAttribute('aria-hidden', String(!active));
    };

    const resetControls = (sliderElement) => {
      const shell = getShell(sliderElement);
      if (!shell) return;

      shell.querySelectorAll('[data-related-products-previous], [data-related-products-next]').forEach((button) => {
        button.classList.remove('swiper-button-disabled', 'swiper-button-lock');
        button.removeAttribute('disabled');
      });

      const pagination = shell.querySelector('[data-related-products-pagination]');
      if (pagination) {
        pagination.className = 'related-products-swiper__pagination';
        pagination.replaceChildren();
      }
    };

    const destroyRelatedProductsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return;

      window.swiperFunctions.destroy(sliderElement);
      resetControls(sliderElement);
      setActiveState(sliderElement, false);
    };

    const initializeRelatedProductsSlider = (sliderElement) => {
      if (!sliderElement || !window.swiperFunctions) return null;

      if (!shouldEnableSlider(sliderElement)) {
        destroyRelatedProductsSlider(sliderElement);
        return null;
      }

      const slides = sliderElement.querySelectorAll(slideSelector);
      if (slides.length < 2) {
        setActiveState(sliderElement, false);
        return null;
      }

      const existingInstance = window.swiperFunctions.getInstance(sliderElement);
      if (existingInstance) {
        setActiveState(sliderElement, true);
        existingInstance.update();
        return existingInstance;
      }

      const shell = getShell(sliderElement);
      const previousButton = shell?.querySelector('[data-related-products-previous]');
      const nextButton = shell?.querySelector('[data-related-products-next]');
      const pagination = shell?.querySelector('[data-related-products-pagination]');
      const columnsDesktop = Math.max(1, Number.parseInt(sliderElement.dataset.columnsDesktop, 10) || 4);
      const columnsMobile = Math.max(1, Number.parseInt(sliderElement.dataset.columnsMobile, 10) || 2);
      const loopRequested = sliderElement.dataset.enableLoop === 'true';
      const enableLoop = loopRequested && slides.length > Math.max(columnsDesktop, columnsMobile);

      setActiveState(sliderElement, true);

      const instance = window.swiperFunctions.init(sliderElement, {
        slidesPerView: columnsMobile,
        spaceBetween: 16,
        speed: prefersReducedMotion ? 0 : 450,
        watchOverflow: true,
        loop: enableLoop,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation:
          previousButton && nextButton
            ? {
                prevEl: previousButton,
                nextEl: nextButton,
              }
            : false,
        pagination: pagination
          ? {
              el: pagination,
              clickable: true,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: columnsDesktop,
            spaceBetween: 24,
          },
        },
        onResize(swiperInstance) {
          swiperInstance.update();
        },
        on: {
          init() {
            setActiveState(sliderElement, true);
          },
          destroy() {
            setActiveState(sliderElement, false);
          },
        },
      });

      if (!instance) {
        resetControls(sliderElement);
        setActiveState(sliderElement, false);
      }

      return instance;
    };

    const initializeWithin = (root = document) => {
      if (root instanceof Element && root.matches(sliderSelector)) {
        initializeRelatedProductsSlider(root);
      }

      root.querySelectorAll?.(sliderSelector).forEach((sliderElement) => {
        initializeRelatedProductsSlider(sliderElement);
      });
    };

    const synchronizeSliders = () => {
      document.querySelectorAll(sliderSelector).forEach((sliderElement) => {
        if (shouldEnableSlider(sliderElement)) {
          initializeRelatedProductsSlider(sliderElement);
        } else {
          destroyRelatedProductsSlider(sliderElement);
        }
      });
    };

    const observeRecommendationRendering = () => {
      recommendationsObserver?.disconnect();

      recommendationsObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            initializeWithin(node);
          });
        });
      });

      recommendationsObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    };

    const initializeModule = () => {
      synchronizeSliders();
      observeRecommendationRendering();

      editorCleanup = window.swiperFunctions.bindShopifyEditor({
        sliderSelector,
        slideSelector,
        initialize: initializeRelatedProductsSlider,
        destroyElement: destroyRelatedProductsSlider,
        onSectionLoad(event, sliderElement) {
          if (sliderElement) {
            initializeRelatedProductsSlider(sliderElement);
          } else if (event?.target) {
            initializeWithin(event.target);
          }
        },
      });

      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', synchronizeSliders);
      } else {
        desktopMedia.addListener(synchronizeSliders);
      }
    };

    if (window.swiperFunctions) {
      initializeModule();
    } else {
      document.addEventListener('swiper-functions:ready', initializeModule, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
